
import * as CONSTANTS from './constants';

const initialState = {
  user: null,
  getSignedAccess: null,
  getProfile: [],
  getAgreements: [],
  saveAgreement: null,
  cancelAgreementData: [],
  dashboardData: null,
  userInfo: [],
  editAgreement: null,
  sendAgreement: null,
  previewAgreement: null,

};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    /*===========*/
    case CONSTANTS.USER_EXISTS_SUCCESS:
      return { ...state, getSignedAccess: action.payload };
    case CONSTANTS.USER_EXISTS_FAILURE:
      return { ...state, getSignedAccess: [] };

    case CONSTANTS.USER_CREATE_SUCCESS:
      return { ...state, user: action.payload };
    case CONSTANTS.USER_CREATE_FAILURE:
      return { ...state, user: action.payload };

    case CONSTANTS.GET_PROFILE_SUCCESS:
      return { ...state, getProfile: action.payload };
    case CONSTANTS.GET_PROFILE_FAILURE:
      return { ...state, getProfile: action.payload };
    // GET_AGREEMENTS getAgreements

    case CONSTANTS.GET_AGREEMENTS_SUCCESS:
      return { ...state, getAgreements: action.payload };
    case CONSTANTS.GET_AGREEMENTS_FAILURE:
      return { ...state, getAgreements: action.payload };

    case CONSTANTS.CREATE_SAVE_AGREEMENT_SUCCESS:
      return { ...state, saveAgreement: action.payload };
    case CONSTANTS.CREATE_SAVE_AGREEMENT_FAILURE:
      return { ...state, saveAgreement: action.payload };

    case CONSTANTS.CANCEL_AGREEMENT_SUCCESS:
      return { ...state, cancelAgreementData: action.payload };
    case CONSTANTS.CANCEL_AGREEMENT_FAILURE:
      return { ...state, cancelAgreementData: action.payload };

    case CONSTANTS.GET_DASHBOARDS_DATA_SUCCESS:
      return { ...state, dashboardData: action.payload };
    case CONSTANTS.GET_DASHBOARDS_DATA_FAILURE:
      return { ...state, dashboardData: action.payload };

    case CONSTANTS.GET_USER_INFO_SUCCESS:
      return { ...state, userInfo: action.payload };
    case CONSTANTS.GET_USER_INFO_FAILURE:
      return { ...state, userInfo: [] };

    case CONSTANTS.GET_EDIT_AGREEMENT_SUCCESS:
      return { ...state, editAgreement: action.payload };
    case CONSTANTS.GET_EDIT_AGREEMENT_FAILURE:
      return { ...state, editAgreement: null };

    case CONSTANTS.SEND_AGREEMENT_SUCCESS:
      return { ...state, sendAgreement: action.payload };
    case CONSTANTS.SEND_AGREEMENT_FAILURE:
      return { ...state, sendAgreement: null };

    case CONSTANTS.PREVIEW_AGREEMENT_SUCCESS:
      return { ...state, previewAgreement: action.payload };

    case CONSTANTS.PREVIEW_AGREEMENT_FAILURE:
      return { ...state, previewAgreement: null };
    /*===========*/

    default:
      return state;
  }
};

export default authReducer;
